const map = (value, minA, maxA, minB, maxB, clamped = false) => {
  if (clamped) value = Math.min(maxA, Math.max(minA, value))
  return ((value - minA) / (maxA - minA)) * (maxB - minB) + minB
}

export default map
